import * as styles from './styles.module.css';
export function getPhoneStyles() {
  return styles;
}